// RS MENU — open dropdown on hover (desktop only)
(() => {
  const rsIsDesktop = () =>
    window.matchMedia("(min-width: 990px)").matches &&
    window.matchMedia("(hover: hover)").matches &&
    window.matchMedia("(pointer: fine)").matches;

  const rsAttach = () => {
    // Dawn / większość motywów Shopify: dropdown w headerze to <details> z .header__menu-item
    const rsItems = document.querySelectorAll(
      "header details.header__menu-item, header .header__inline-menu details"
    );

    rsItems.forEach((rsDetails) => {
      let rsCloseTimer = null;

      const rsOpen = () => {
        if (!rsIsDesktop()) return;
        clearTimeout(rsCloseTimer);
        rsDetails.setAttribute("open", "open");
      };

      const rsClose = () => {
        if (!rsIsDesktop()) return;
        clearTimeout(rsCloseTimer);
        rsCloseTimer = setTimeout(() => {
          rsDetails.removeAttribute("open");
        }, 140); // lekki delay = mniej “migania”
      };

      // otwieraj na hover
      rsDetails.addEventListener("mouseenter", rsOpen);
      rsDetails.addEventListener("mouseleave", rsClose);

      // jeśli user kliknie poza — zamknij
      document.addEventListener("click", (e) => {
        if (!rsIsDesktop()) return;
        if (!rsDetails.contains(e.target)) rsDetails.removeAttribute("open");
      });

      // ESC zamyka
      rsDetails.addEventListener("keydown", (e) => {
        if (e.key === "Escape") rsDetails.removeAttribute("open");
      });
    });
  };

  document.addEventListener("DOMContentLoaded", rsAttach);
})();